import { ApiService, HttpResponse } from "./ApiService";
import { GetClientSettings } from "./SettingsService";
import { ISalvageClientSettings } from "../interfaces/ISalvageClientSettings";
import { IGlobalAlert } from "../interfaces/IGlobalAlert";

const ClientSettings: ISalvageClientSettings = GetClientSettings();

export async function findSingleActive() {
  return await ApiService().Get<IGlobalAlert>(`${ClientSettings.AuctionPublicApiUrl}/alert/active`);  
}